import type { ReactNode } from 'react';

interface Props {
  title: string;
  hint?: string;
  action?: ReactNode;
  icon?: ReactNode;
}

export function EmptyState({ title, hint, action, icon }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-slate-300 bg-white px-6 py-10 text-center">
      {icon && <div className="text-3xl text-slate-400">{icon}</div>}
      <p className="text-sm font-medium text-slate-700">{title}</p>
      {hint && <p className="max-w-sm text-xs text-slate-500">{hint}</p>}
      {action}
    </div>
  );
}
